DR.top = DR.top || {};
DR.top.struct = DR.top.struct || {};
DR.top.select = DR.top.select || {};
/** @extends {DR._Base} */
DR.top.struct.Task = function(par){
	/** @private */
	this._t = 1158;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
};
DR._Base._types[1158] = DR.top.struct.Task;
DR.top.struct.Task.TYPE_IMAGEMATCH = "imagematch";
DR.top.struct.Task.TYPE_QUESTION = "question";
DR.top.struct.Task.TYPE_PACMAN = "pacman";
DR.top.struct.Task.TYPE_BRAINTEASER = "brainteaser";
DR.top.struct.Task.TYPE_CRAZYWOLF = "crazywolf";
DR.top.struct.Task.TYPE_HOTCOLD = "hotcold";
DR.top.struct.Task.TYPE_PENALTY = "penalty";
DR.top.struct.Task.TYPE_CODER = "coder";
DR.top.struct.Task.TYPE_FINISH = "finish";
DR.top.struct.Task.TYPE_DETECTIVE = "detective";
DR.top.struct.Task.TYPE_TREASURE = "treasure";
DR.top.struct.Task.TYPE_GOLDDIGGER = "golddigger";
DR.top.struct.Task[__P] = new DR._Base;
DR.top.struct.Task[__P][__C] = DR.top.struct.Task;
/** @type {Number} */
DR.top.struct.Task.prototype.points = null;
/** @type {String} */
DR.top.struct.Task.prototype.type = null;
 
/** @extends {DR._Base} */
DR.top.struct.TeamsListItem = function(par){
	/** @private */
	this._t = 1331;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.name)) this.name = String(par.name||'');
};
DR._Base._types[1331] = DR.top.struct.TeamsListItem;
DR.top.struct.TeamsListItem[__P] = new DR._Base;
DR.top.struct.TeamsListItem[__P][__C] = DR.top.struct.TeamsListItem;
/** @type {Number} */
DR.top.struct.TeamsListItem.prototype.id = null;
/** @type {String} */
DR.top.struct.TeamsListItem.prototype.name = null;
 
/** @extends {DR._Base} */
DR.top.struct.TopItem = function(par){
	/** @private */
	this._t = 1155;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.disqualified)) this.disqualified = Boolean(par.disqualified);
	if(DR._Base.is(par.duration)) this.duration = (parseInt(par.duration)||0);
	if(DR._Base.is(par.games)) this.games = (parseInt(par.games)||0);
	if(DR._Base.is(par.place)) this.place = (parseInt(par.place)||0);
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.tasks)){
		var tmp = [];
		for( var k in par.tasks ) tmp.push(DR._Base.cast(par.tasks [k]));
		this.tasks = tmp;
	}
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1155] = DR.top.struct.TopItem;
DR.top.struct.TopItem[__P] = new DR._Base;
DR.top.struct.TopItem[__P][__C] = DR.top.struct.TopItem;
/** @type {Boolean} */
DR.top.struct.TopItem.prototype.disqualified = null;
/** @type {Number} */
DR.top.struct.TopItem.prototype.duration = null;
/** @type {Number} */
DR.top.struct.TopItem.prototype.games = null;
/** @type {Number} */
DR.top.struct.TopItem.prototype.place = null;
/** @type {Number} */
DR.top.struct.TopItem.prototype.points = null;
/** @type {Array.<DR.top.struct.Task>} */
DR.top.struct.TopItem.prototype.tasks = null;
/** @type {DR.teams.struct.Team} */
DR.top.struct.TopItem.prototype.team = null;
 
/** @extends {DR._Base} */
DR.top.struct.TeamsList = function(par){
	/** @private */
	this._t = 1332;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.teams)){
		var tmp = [];
		for( var k in par.teams ) tmp.push(DR._Base.cast(par.teams [k]));
		this.teams = tmp;
	}
};
DR._Base._types[1332] = DR.top.struct.TeamsList;
DR.top.struct.TeamsList[__P] = new DR._Base;
DR.top.struct.TeamsList[__P][__C] = DR.top.struct.TeamsList;
/** @type {Array.<DR.top.struct.TeamsListItem>} */
DR.top.struct.TeamsList.prototype.teams = null;
 
/** @extends {DR._Base} */
DR.top.struct.GetTopRe = function(par){
	/** @private */
	this._t = 1156;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.count)) this.count = (parseInt(par.count)||0);
	if(DR._Base.is(par.items)){
		var tmp = [];
		for( var k in par.items ) tmp.push(DR._Base.cast(par.items [k]));
		this.items = tmp;
	}
	if(DR._Base.is(par.pgs)) this.pgs = (parseInt(par.pgs)||0);
};
DR._Base._types[1156] = DR.top.struct.GetTopRe;
DR.top.struct.GetTopRe[__P] = new DR._Base;
DR.top.struct.GetTopRe[__P][__C] = DR.top.struct.GetTopRe;
/** @type {Number} */
DR.top.struct.GetTopRe.prototype.count = null;
/** @type {Array.<DR.top.struct.TopItem>} */
DR.top.struct.GetTopRe.prototype.items = null;
/** @type {Number} */
DR.top.struct.GetTopRe.prototype.pgs = null;
 
/** @extends {DR._Method} */
DR.top.GetTeam = function(par){
	this.select = [];
	/** @private */
	this._t = 1334;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1334] = DR.top.GetTeam;
DR.top.GetTeam[__CL] = "Top__GetTeam";
DR.top.GetTeam[__P] = new DR._Method;
DR.top.GetTeam[__P][__C] = DR.top.GetTeam;
/** @type {Number} */
DR.top.GetTeam.prototype.teamId = null;
/** @type {DR.top.struct.TopItem} */
DR.top.GetTeam.prototype.re = null;
 
/** @extends {DR._Method} */
DR.top.GetTeams = function(par){
	this.select = [];
	/** @private */
	this._t = 1333;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1333] = DR.top.GetTeams;
DR.top.GetTeams[__CL] = "Top__GetTeams";
DR.top.GetTeams[__P] = new DR._Method;
DR.top.GetTeams[__P][__C] = DR.top.GetTeams;
/** @type {DR.top.struct.TeamsList} */
DR.top.GetTeams.prototype.re = null;
 
/** @extends {DR._Method} */
DR.top.GetTop = function(par){
	this.select = [];
	/** @private */
	this._t = 1157;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1157] = DR.top.GetTop;
DR.top.GetTop[__CL] = "Top__GetTop";
DR.top.GetTop[__P] = new DR._Method;
DR.top.GetTop[__P][__C] = DR.top.GetTop;
/** @type {Number} */
DR.top.GetTop.prototype.count = null;
/** @type {Number} */
DR.top.GetTop.prototype.pg = null;
/** @type {DR.top.struct.GetTopRe} */
DR.top.GetTop.prototype.re = null;
 
D.loaded();